import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import ProductCard from '../ProductCard';
import { Icons } from "../../Data/cardData";
import './style.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Fade } from '@mui/material';

export default function ProductExample() {
  const [itemsPerPage, setItemsPerPage] = useState(3);

  useEffect(() => {
    const updateItemsPerPage = () => {
      const windowWidth = window.innerWidth;
      if (windowWidth >= 1200) {
        setItemsPerPage(3);
      } else if (windowWidth >= 700) {
        setItemsPerPage(3);
      } else {
        setItemsPerPage(2);
      }
    };

    updateItemsPerPage();
    window.addEventListener('resize', updateItemsPerPage);

    return () => {
      window.removeEventListener('resize', updateItemsPerPage);
    };
  }, []);

  const settings = {
    autoplay: true,
    dots: true,
    infinite: true,
   speed: 800,
    autoplaySpeed: 1200,
    slidesToShow: itemsPerPage,
    slidesToScroll: 1,
    className: 'custom-slider', 
    cssEase: "linear"
  };
  
  return (
    <div className="slider-container">
      <Slider {...settings}>
        {Icons
          .map((produit, index) => (
            <ProductCard
            key={produit.nom + index}
            name={produit.nom}
            index={index}
            />
          ))}
      </Slider>
    </div>
  );
          }